<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { get } from 'svelte/store';
    import { api } from '../../../stores/api';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import ErrorInline from '../../shared/ErrorInline.svelte';
    import { TacticalPlanApi } from './TacticalPlanApi';

    export let tacticalPlanId: number;

    let exporting: boolean = false;
    let error: string = '';

    async function handleExport() {
        exporting = true;
        error = '';
        try {
            const plan = await TacticalPlanApi.exportToJson(get(api), tacticalPlanId);
            const blob = new Blob([JSON.stringify(plan, null, 2)], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `tactical_plan_${tacticalPlanId}.json`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error('TacticalPlanJsonExportButton', err);
            error = $_('tp_export_json_failed', { values: { error: $_(String(err)) } });
        } finally {
            exporting = false;
        }
    }
</script>

<span data-testid="tactical-plan-json-export">
    <ButtonMain disabled={exporting} text={$_('tp_export_json_button')} on:click={handleExport} />
    {#if error}
        <ErrorInline text={error} />
    {/if}
</span>
